import styled from 'styled-components/native';

export default styled.View<{ isModalOpen?: boolean }>`
  width: 100%;
  padding-bottom: 100px;
  ${({ isModalOpen }) => isModalOpen && `z-index: -1;`}
`;
